import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Baby, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF6F0] flex items-center justify-center px-4" data-testid="forgot-password-page">
      <div className="w-full max-w-md animate-fade-up">
        <div className="flex flex-col items-center mb-8">
          <div className="w-14 h-14 rounded-2xl bg-[#E07A5F] flex items-center justify-center shadow-lg mb-3">
            <Baby className="w-8 h-8 text-white" />
          </div>
          <h1 className="font-heading text-2xl font-semibold text-[#3D405B]">Recupera password</h1>
        </div>
        <div className="card-warm p-8">
          {done ? (
            <div className="text-center space-y-4" data-testid="forgot-password-success">
              <p className="text-sm text-[#3D405B]">
                Se l'email è registrata, riceverai un link per reimpostare la password.
              </p>
              <Link to="/login" data-testid="back-to-login-link" className="text-[#b0563a] font-semibold hover:underline text-sm">
                Torna al login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
              <div>
                <label className="label-warm block mb-2">Email</label>
                <div className="relative">
                  <Mail className="w-4 h-4 absolute left-4 top-1/2 -translate-y-1/2 text-[#a89a8a]" />
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    data-testid="forgot-email-input" className="input-warm pl-11" placeholder="nome@email.it" />
                </div>
              </div>
              {error && <p className="text-sm text-red-600" data-testid="forgot-error">{error}</p>}
              <button type="submit" disabled={loading} data-testid="forgot-submit-button" className="btn-warm w-full">
                {loading ? "Invio..." : "Invia link di reset"}
              </button>
              <Link to="/login" data-testid="back-to-login-link" className="block text-center text-sm text-[#b0563a] hover:underline font-medium">
                Torna al login
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
